/**
 * Nav chip for Clubs / Toolkit. Show PRO only after we know the user
 * is not entitled. Unknown (loading) and Pro stay quiet.
 */
export function navProBadgeText(hasEntitlement) {
  return hasEntitlement === false ? 'PRO' : null;
}
